import React, { useCallback } from "react";
import { Text, makeStyles, Tooltip, Button } from "@fluentui/react-components";
import { ArrowLeft16Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "16px",
    paddingRight: "16px",
    gap: "12px",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  titleExtra: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default function AdminTopbar({
  title,
  onBack,
  titleTooltip, // optional tooltip for title, useful when title is truncated
  backTooltip = "Back",
  titleExtra, // ReactNode
}) {
  const styles = useStyles();

  const handleBack = useCallback(() => {
    if (typeof onBack === "function") {
      onBack();
    }
  }, [onBack]);

  return (
    <div className={styles.root}>
      {/*  Left Section */}
      <div className={styles.leftSection}>
        {onBack && (
          <Tooltip content={backTooltip} relationship="label">
            <Button
              appearance="subtle"
              icon={<ArrowLeft16Regular />}
              onClick={handleBack}
            />
          </Tooltip>
        )}

        {/*  Title + Extra */}
        <div className={styles.titleWrapper}>
          {titleTooltip ? (
            <Tooltip content={titleTooltip} relationship="label">
              <Text weight="semibold" color="brand">
                {title}
              </Text>
            </Tooltip>
          ) : (
            <Text weight="semibold" color="brand">
              {title}
            </Text>
          )}
          {titleExtra && <div className={styles.titleExtra}>{titleExtra}</div>}
        </div>
      </div>
    </div>
  );
}
